import { useState } from 'react';
import { OrganizationApi, ToastStateHandler } from '../../../api';
import { dispatch } from '../../../store';
import { setBranchAsMain } from '../../../store/slices/branch.slice';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpPostSetBranchAsMain = () => {
    const { t } = useTranslation('newNotifications');
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const [isChanged, setIsChanged] = useState(false);

    const exec = (id: string) => {
        const { exec, abort } = organizationApi.setBranchAsMain({
            params: { id },
            onSuccess: _ => {
                dispatch(setBranchAsMain({ branchId: id }));
                toastHandler.push('success', t('branch.setBranchAsMainTitle'), t('branch.setBranchAsMainMessage_Success'));
                setIsChanged(true);
            },
            onError: _ => toastHandler.push('error', t('branch.setBranchAsMainTitle'), t('branch.setBranchAsMainMessage_Failed')),
        });
        exec();
        return abort;
    };

    return { exec, isChanged };
};

export default useHttpPostSetBranchAsMain;
